import { render } from "./PageWithTitle.vue?vue&type=template&id=2c8378f1&scoped=true"
import script from "./PageWithTitle.vue?vue&type=script&lang=js"
export * from "./PageWithTitle.vue?vue&type=script&lang=js"

import "./PageWithTitle.vue?vue&type=style&index=0&id=2c8378f1&lang=scss"
import "./PageWithTitle.vue?vue&type=style&index=1&id=2c8378f1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c8378f1"

export default script